import React, { useState, useEffect, useRef } from 'react';

const AboutBenefit = () => {
  const [isContentChanged, setIsContentChanged] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const scrollableContentRef = useRef(null);
  const scrollThumbRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleThumbDrag = (e) => {
    if (isMobile) return;

    const scrollableContent = scrollableContentRef.current;
    const startY = e.clientY;
    const startScrollTop = scrollableContent.scrollTop;

    const onMouseMove = (moveEvent) => {
      const deltaY = moveEvent.clientY - startY;
      const newScrollTop = startScrollTop + deltaY;

      scrollableContent.scrollTop = Math.min(
        Math.max(newScrollTop, 0),
        scrollableContent.scrollHeight - scrollableContent.clientHeight
      );
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const handleScroll = () => {
    if (isMobile) return;

    const scrollableContent = scrollableContentRef.current;
    const scrollThumb = scrollThumbRef.current;

    const scrollHeight = scrollableContent.scrollHeight;
    const scrollTop = scrollableContent.scrollTop;
    const clientHeight = scrollableContent.clientHeight;

    const thumbHeight = Math.max((clientHeight / scrollHeight) * clientHeight, 30);
    const thumbPosition = (scrollTop / (scrollHeight - clientHeight)) * (clientHeight - thumbHeight);

    scrollThumb.style.height = `${thumbHeight}px`;
    scrollThumb.style.marginTop = `${thumbPosition}px`;
  };

  useEffect(() => {
    if (!isMobile) {
      const scrollableContent = scrollableContentRef.current;
      if (scrollableContent) {
        handleScroll();
        scrollableContent.addEventListener('scroll', handleScroll);
        return () => {
          scrollableContent.removeEventListener('scroll', handleScroll);
        };
      }
    }
  }, [isMobile]);

  return (
    <div
      className="pt-80 pb-80"
      style={{
        background: '#f2f0ed',
        backgroundSize: '200% 200%',
        animation: 'gradientBackground 15s ease infinite',
      }}
    >
      <div className="mx-auto grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-8 text-left custom-padding-about xl-screen-padding-about relative">
          <h1 className="text-4xl text-black mb-6 font-merriweather">
            How <span className="text-[#8f762c]">Nutrigenomics</span> Can Benefit You
          </h1>

          <div className="relative">
            {!isMobile && (
              <div
                className="absolute left-[-20px] top-0 bottom-0"
                style={{
                  width: '10px',
                  background: 'white',
                  borderRadius: '5px',
                  overflow: 'hidden',
                }}
              >
                <div
                  id="scrollThumb"
                  ref={scrollThumbRef}
                  className="scrolltext"
                  style={{
                    background: '#c4b69a',
                    borderRadius: '5px',
                    height: '10%',
                    marginTop: '0',
                    transition: 'margin-top 0.2s ease',
                    cursor: 'pointer',
                  }}
                  onMouseDown={handleThumbDrag}
                ></div>
              </div>
            )}

            <div
              id="scrollableContent"
              ref={scrollableContentRef}
              className="bg-white p-3 rounded-lg shadow-lg mb-8"
              style={{
                height: isMobile ? 'auto' : '300px',
                overflowY: isMobile ? 'visible' : 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              <>
                <p className="text-[#aeaea6] mb-6 text-p" onClick={() => setIsContentChanged(!isContentChanged)}>
                  Nutrigenomics explores how your genes influence your body’s response
                  to food, enabling the identification of nutrients, vitamins, and dietary
                  choices that align with your genetic makeup. By combining this insight
                  with gut microbiome analysis, which assesses digestive health, we
                  develop personalised, effective, and sustainable nutrition plans.                  </p>
                <p className="text-[#aeaea6] text-p" onClick={() => setIsContentChanged(!isContentChanged)}>
                  This innovative approach merges the fields of nutrition and genetics to
                  create tailored dietary strategies that optimize health, matching the right
                  foods and supplements to your unique DNA. Nutrigenomics can help
                  manage hereditary conditions like high blood pressure, enhance weight
                  management by understanding how your body processes carbohydrates
                  and fats, and even address genetically predisposed cravings                  </p>
                <p className="text-[#aeaea6] text-p mb-6" onClick={() => setIsContentChanged(!isContentChanged)}>
                  Beyond mitigating health risks, nutrigenomics is designed to maximize
                  energy levels, improve athletic performance, and support overall well-being. By offering customized guidance, it empowers individuals to make
                  sustainable health choices and take control of their wellness journey                  </p>
                <p className="text-[#aeaea6] text-p" onClick={() => setIsContentChanged(!isContentChanged)}>
                  From enhancing sports performance to boosting everyday vitality,
                  nutrigenomics is transforming nutrition by tailoring dietary solutions to
                  each person’s genetic profile, making every plan as unique as your DNA
                </p>
              </>
            </div>
          </div>
        </div>
        <div className="col-span-12 md:col-span-4 flex items-center justify-end relative">
          <div className="flex items-center justify-center">
            <div className="absolute top-0 bottom-0 w-3/4 bg-white rounded-l-full transformimg2"></div>
            <div className="Nutriimg overflow-hidden z-10 custom-translate2">
              <img
                src={require('../../src/assets/images/benefitimage.png')}
                alt="Appointment"
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutBenefit;
